
let formData = {}

// 不需要遍历子字段的
// images -> 主图列表
// verticalImage -> 长图列表
const NO_NEED_CHILDREN_NAMES = ['images', 'verticalImage', 'threeToFourImages']

/**
 * 生成 form 表单绑定对象
 * @param {*} formSections 
 */
export const generateFormData = (formSections, parent) => {
    formSections.forEach(item => {
        const fields = item.children, name = item.name

        if (NO_NEED_CHILDREN_NAMES.includes(name)) {
            formData[name] = ''
            return;
        }

        if (fields) {
            generateFormData(fields, item)
        } else {

            formData[name] = ''
        }
    })
    // console.log(formData, '-----formdata')
    return formData
}

/**
 * 提供 form 表单绑定数据
 * @param {*} formSections 
 * @returns 
 */
export const getFormData = (formSections) => {
    if (!Array.isArray(formSections) || formSections.length <= 0) return []
    formData = {}
    return generateFormData(formSections)
}